import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { forwardRef } from "react";
import { ArrowRightIcon } from "../../icons/ArrowRightIcon";
import { NakedButton } from "../../naked-button/NakedButton";
import { useNestLevel } from "../nest-level-context";
import * as Styled from "./ExpandableCell.styled";
export const ExpandableCell = forwardRef((props, ref) => {
    const { nestLevel, isExpanded = false, children, collapseText = "Collapse row", expandText = "Expand row", onToggle, isHeader, ...otherProps } = props;
    const nestLevelFromContext = useNestLevel();
    const nestLevelToUse = typeof nestLevel === "number" && Number.isFinite(nestLevel) ? nestLevel : nestLevelFromContext;
    return (_jsx(Styled.ExpandableCell, { ref: ref, nestLevel: nestLevelToUse, isExpanded: isExpanded, isHeader: isHeader, ...otherProps, children: _jsxs("div", { children: [children, onToggle && (
                // DO NOT CHANGE SOURCE ORDER HERE: Expand toggle must
                // appear after children for proper a11y header row reading
                _jsx(NakedButton, { onClick: onToggle, "aria-expanded": isExpanded, role: "button", children: _jsx(ArrowRightIcon, { size: "16px", "aria-label": isExpanded ? collapseText : expandText }) }))] }) }));
});
ExpandableCell.displayName = "ExpandableCell";
